// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"7833ef44","186":"78a64aa7","344":"e3addb6c","372":"28d44c16","738":"04256520","787":"16275dd0","841":"8b064916","856":"11a29358"}[chunkId] + ".chunk.js";
};